import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
// Internal dependencies
import { UserContext } from '../auth';
/**
 * Protect private routes
 * @param {any} props
 * @returns {JSX.Element}
 */
export const RequiredAuth = function (props) {
    const { children } = props;
    // React Router Dom location
    const location = useLocation();
    // Authorized user context
    const user = useContext(UserContext);
    // Send pathname, search to the sign in for redirect after signed in successfully
    return (user ? children : _jsx(Navigate, { to: "/sign-in", replace: true, state: { pathname: location.pathname, search: location.search } }));
};
